import type { SearchResponseData, SearchResultPayload } from '@/types'

export const unwrapSearchResult = <TProduct>(
  data: SearchResponseData<TProduct>
): SearchResultPayload<TProduct> => {
  if ('result' in data && data.result) return data.result
  return data as SearchResultPayload<TProduct>
}
